import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import type { User } from '@/types/auth.types';

interface RequireRoleProps {
  children: ReactNode;
  allowedRoles: User['role'][];
}

/**
 * Declarative UI gate: renders children only when the current user role is allowed.
 * Does not replace route guards or API authorization.
 */
const RequireRole: React.FC<RequireRoleProps> = ({ children, allowedRoles }) => {
  const role = useSelector((state: RootState) => state.auth.user?.role);

  if (!role || !allowedRoles.includes(role)) {
    return null;
  }

  return <>{children}</>;
};

export default RequireRole;
